import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.125 17.3125C2.08211 17.3125 2.0388 17.3076 1.99591 17.2977C1.74208 17.2373 1.5625 17.0109 1.5625 16.75C1.5625 11.6386 2.20909 7.38747 10 7.19411V3.25C10 3.02641 10.1323 2.82433 10.3368 2.73475C10.5406 2.64574 10.7795 2.68427 10.9443 2.83699L18.2568 9.58699C18.3721 9.69288 18.4375 9.84293 18.4375 10C18.4375 10.1571 18.3721 10.3071 18.2568 10.4132L10.9443 17.1632C10.78 17.3159 10.5411 17.3554 10.3368 17.2654C10.1323 17.1757 10 16.9736 10 16.75V12.8191C4.65569 12.9471 3.66963 14.9186 2.62816 17.0016C2.53155 17.1955 2.33425 17.3125 2.125 17.3125ZM10.5625 11.6875C10.8734 11.6875 11.125 11.9391 11.125 12.25V15.4651L17.0456 10L11.125 4.53489V7.75C11.125 8.06093 10.8734 8.3125 10.5625 8.3125C4.34856 8.3125 3.01052 10.7158 2.74741 14.5544C3.91248 12.9894 5.89825 11.6875 10.5625 11.6875Z",
		fill: "currentColor"
	})
});
export default SvgSend;
